const initialState = {
  currentLevel: 'map',
  gameLevels: {
    map: 'map',
    forest: 'forest',
  },
  forest: {
    player: {
      position: {
        x: 0,
        z: 0
      },
      rotation: {
        y: 0
      }
    }
  }
}

const getGameState = () => {
  return initialState
}

export {
  getGameState
}